const ITEMS = [
  "Prevenção de perdas",
  "Monitoramento",
  "Rastreamento",
  "Resgate",
  "Assistência técnica",
  "Economia real",
  "Sustentabilidade",
  "Atuação nacional",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      className="relative overflow-hidden border-y border-white/10 bg-[#162B63] py-5"
      data-testid="editorial-marquee"
    >
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center gap-8 pr-8 font-tech text-sm uppercase tracking-[0.3em] text-slate-500"
              >
                {item}
                <span className="h-1.5 w-1.5 rounded-full bg-[#FF5722]/70" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
